<template>
	<div class="assessment-header">
		<div>
			<UserAvatar
				:user="user"
				size="3.5rem"
			/>
		</div>
		<div class="assessment-header__details">
			<div class="assessment-header__name">
				<h2 :class="nameClasses">{{ user.displayName }}</h2>
				<div v-if="moniker" :class="monikerClasses">{{ moniker }}</div>
			</div>
			<!-- disabling motto for now, per Jeff & Stephen -->
			<!-- FEATUREFLAG -->
			<p v-if="false && motto" class="assessment-header__motto"><em>{{ motto }}</em></p>
			<AssessmentDescriptors :assessment="assessment" />
		</div>
	</div>
</template>

<script>
import UserAvatar from "../UserAvatar";
import AssessmentDescriptors from "./AssessmentDescriptors";
export default {
	name: "AssessmentHeader",
	components: {
		UserAvatar,
		AssessmentDescriptors,
	},
	props: {
		user: {
			type: Object,
			required: true,
		},
		assessment: {
			type: Object,
			required: false,
		},
	},
	computed: {
		nameClasses() {
			const { highType, } = this;
			return {
				"text-ms2": true,
				[ `discTextLabel__${ highType }-hightype-label` ]: true,
			};
		},
		monikerClasses() {
			const { highType, } = this;
			return {
				"text-ms2": true,
				"discTextLabel__hightype-chip": true,
				[ `discTextLabel__${ highType }-hightype-chip` ]: true,
			};
		},
		moniker() {
			return this.assessment?.moniker || "";
		},
		highType() {
			return ( this.moniker || [ "", ] )[ 0 ].toUpperCase();
		},
		motto() {
			return this.assessment?.teamingContent?.motto || "";
		},
	},
	methods: {},
};
</script>

<style lang="scss" scoped>
.assessment-header {
	display: flex;
	flex-direction: row;
	justify-content: flex-start;
	gap: 1rem;
}

.assessment-header__details {
	display: flex;
	flex-direction: column;
	gap: 0.5rem;

	text-align: left;

}

.assessment-header__name {
	display: flex;
	flex-direction: row;
	justify-content: flex-start;
	align-items: center;
	gap: 0.5rem;

	@include font-and-line-for(2);
}

.assessment-header__motto {
	@include font-and-line-for(0);
}
</style>
